import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useT } from '@progress-fe/core';
import { Box } from '@chakra-ui/react';
import { SimpleTable } from '../../tables';
import { DialogableContainer } from '../../containers';
import { useJsFieldFormData } from '../../../hooks';
import { tableDataUtils } from '../../../utils';
import { JsFormConfigContext } from '../../../contexts';
import { isGroupedRow } from '../../tables/SimpleTable/SimpleTable.utils';
import { JsFieldInspector } from '../../jsFormBase';
const DEFAULT_TABLE_HEIGHT = 300;
/**
 * Component renders "/schemas/jsf-complex-table" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TTableFormData.
 */
export const ComplexTableJsField = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const { t } = useT();
    const { fieldConfig, fieldValues, onChangeFieldValues } = useJsFieldFormData({
        config: props.formData?.fieldConfig ?? null,
        values: props.formData?.fieldValues ?? null,
        onChange: props.onChange,
        watchPropsChanges: true
    });
    const columns = fieldConfig?.columns ?? [];
    const rows = fieldValues ?? [];
    const handleValueChange = (rowId, newValue, _prevValue, groupId) => {
        if (!fieldValues) {
            return;
        }
        let newTableData = [];
        if (groupId === undefined) {
            const editedValue = { ...fieldValues[rowId], value: newValue };
            newTableData = tableDataUtils.changeValueById(fieldValues, editedValue, rowId);
        }
        else {
            const groupRow = structuredClone(fieldValues[groupId]);
            if (!isGroupedRow(groupRow)) {
                return;
            }
            const editedValue = { ...groupRow.items[rowId], value: newValue };
            groupRow.items[rowId] = editedValue;
            newTableData = tableDataUtils.changeValueById(fieldValues, groupRow, groupId);
        }
        onChangeFieldValues(newTableData);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { pb: "2px", children: _jsx(DialogableContainer, { "data-testid": "ComplexTableJs-test", "data-name": props.name, title: props.schema.title ?? '', dialogMinWidth: "70%", floatMinWidth: "30%", children: _jsx(SimpleTable, { columns: columns, rows: rows, noItemsTitle: t('common.noData'), onValueChange: handleValueChange, tableSx: {
                        height: fieldConfig?.height ?? DEFAULT_TABLE_HEIGHT
                    } }) }) }) }));
};
//# sourceMappingURL=ComplexTableJsField.js.map